export default __webpack_public_path__ + "static/media/Vendors.94b74412.xlsx";